// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"637b2039","412":"f2346f1b","512":"f2346f1b","548":"c84b7676"}[chunkId] + ".chunk.css";
};